import { menuListItems } from "assets/menu/menuList";
import { BreadCrumb } from "components/BreadCrumb";
import { GoToBack } from "components/GoToBack";
import { Header } from "components/Header";
import { Menu } from "components/Menu";
import React from "react";
import { useParams } from "react-router-dom";

import { LocationForm } from "../LocationForm";
import { HeaderContainer } from "./styles";

export const LocationEdit: React.FC = () => {
  const { eventId, locationId } = useParams<{
    eventId: string;
    locationId: string;
  }>();

  return (
    <Menu links={menuListItems}>
      <Header>
        <HeaderContainer>
          <div>
            <GoToBack />
          </div>

          <div className="header-text">
            <BreadCrumb
              itens={["Eventos", "Detalhes", "Editar Local"]}
              itemActive="Editar Local"
            />
          </div>
        </HeaderContainer>
      </Header>

      <LocationForm eventId={eventId} locationId={locationId} />
    </Menu>
  );
};
